<h2 mat-dialog-title class="dialog-header">{{'pool.details.title'|traduccion}} {{data?.pool?.id}}
  <button mat-icon-button class="close-btn" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<mat-dialog-content class="dialog-content mat-typography">
  <div appGridColumns [colsLg]="1" [colsMd]="1" [colsSm]="1">
    <mat-card>
      <p><strong>{{'pool.details.id'|traduccion}}:</strong> {{ data?.pool?.id }}</p>
      <p>
        <strong>{{'pool.details.status'|traduccion}}:</strong>
        <span class="badge-state" [ngClass]="data?.pool?.status.toLowerCase()">{{ data?.pool?.status|traduccion }}</span>
      </p>
      <p><strong>{{'pool.details.leasedFrom'|traduccion}}:</strong> {{  data?.pool?.leasedFrom | date: appService.FORMAT_DATETIME }}</p>
      <p><strong>{{'pool.details.leasedUntil'|traduccion}}:</strong> {{  data?.pool?.leasedUntil | date: appService.FORMAT_DATETIME }}</p>
      <p><strong>{{'pool.details.version'|traduccion}}:</strong> {{  data?.pool?.version }}</p>
    </mat-card>
  </div>

  <mat-card>
    <h3>{{'pool.details.table.title'|traduccion}}</h3>
    <app-data-table
      shellClass="table-card mat-elevation-z1"
      [dataSource]="dataSource"
      [displayedColumns]="displayedColumns"
      [emptyMessage]="'No hay elementos en el pool.'"
      [showPaginator]="true"
      [clientPagination]="true"
      [pageSize]="10"
      [pageSizeOptions]="[10, 25, 50]"
      [showFirstLastButtons]="true"
      [stickyHeader]="true">
      <ng-container matColumnDef="seq">
        <th mat-header-cell *matHeaderCellDef>{{'pool.details.table.header.seq'|traduccion}}</th>
        <td mat-cell *matCellDef="let r">{{ r.seq }}</td>
      </ng-container>

      <ng-container matColumnDef="boxId">
        <th mat-header-cell *matHeaderCellDef>{{'pool.details.table.header.boxId'|traduccion}}</th>
        <td mat-cell *matCellDef="let r">{{ r.boxId }}</td>
      </ng-container>

      <ng-container matColumnDef="consumedAt">
        <th mat-header-cell *matHeaderCellDef>{{'pool.details.table.header.consumedAt'|traduccion}}</th>
        <td mat-cell *matCellDef="let r">{{ r.consumedAt|date:'dd-MM-yyyy HH:mm' }}</td>
      </ng-container>

      <ng-container matColumnDef="reservationId">
        <th mat-header-cell *matHeaderCellDef>{{'pool.details.table.header.reservationId'|traduccion}}</th>
        <td mat-cell *matCellDef="let r">{{ r.reservationId }}</td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let r">
          <button mat-stroked-button color="warn" (click)="consumeItemPool(r.id)">{{'pool.details.action.consume'|traduccion}}</button>
        </td>
      </ng-container>
    </app-data-table>
  </mat-card>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-footer">
  <span class="spacer"></span>
  <button mat-stroked-button color="warn" (click)="consumePool()">{{'pool.details.action.consume'|traduccion}}</button>
</mat-dialog-actions>
